import { combineReducers } from "redux";
import dhsApplicationDataStore from "./dhsAppData";

const rootReducer = combineReducers({
    dhsApplicationDataStore: dhsApplicationDataStore
});

export default rootReducer;